module.exports = __webpack_public_path__ + "static/media/TW.7617e979.png";